<div class="search-page">
  <mat-sidenav-container class="search-page__container">
    <mat-sidenav class="search-page__sidebar" mode="side" [opened]="sidebarOpened" (openedChange)="onSidebarOpenedChange()">
      <div class="search-page__header">
        <app-search-form #form class="search__form" [query]="query" [activityState]="activityState"
                         (queryChanged)="search()" (locationStateChanged)="onLocationStateChanged($event)"
                         (error)="onError($event)">
        </app-search-form>
        <a href="#" (click)="onClickNewSearch($event)" mat-button type="button" class="search-page__new-search-btn">
          <mat-icon>search</mat-icon>
          <span class="search-page__new-search-text">New Search</span>
        </a>
      </div>
      <mat-tab-group #tabGroup disableRipple="true" [@.disabled]="true" (selectedTabChange)="onSelectTab($event)">
        <mat-tab #airportsTab>
          <ng-template mat-tab-label>
            <div class="search-page__tab">
              <mat-icon class="search-page__tab-icon">airplanemode_active</mat-icon>
              <span class="search-page__tab-text">Airports</span>
            </div>
          </ng-template>
          <app-airport-results-listing
            #airportResultsListing class="search-page__results" [query]="query"
            [state]="airportState" [airports]="pagedAirports" [activeAirport]="activeAirport"
            [pageIndex]="pageIndex" [pageSize]="pageSize" [totalAirports]="filteredAirports.length"
            (filtersChanged)="onFiltersChanged(false)" (publicUseChanged)="onPublicUseChanged()"
            (pageChanged)="onPageChanged($event)"
            (fuelPriceToggleChanged)="onFuelPriceToggleChanged()"
            (airportMouseEnter)="onAirportCardHover($event, true)"
            (airportMouseLeave)="onAirportCardHover($event, false)">
          </app-airport-results-listing>
        </mat-tab>
        <mat-tab #activitiesTab>
          <ng-template mat-tab-label>
            <div class="search-page__tab">
              <mat-icon class="search-page__tab-icon">location_on</mat-icon>
              <span class="search-page__tab-text">Nearby Activities</span>
            </div>
          </ng-template>
          <app-activity-results-listing
            #activityResultsListing class="search-page__results" [query]="query"
            [state]="activityState" [activities]="activities" [activeActivity]="selectedActivity"
            (selectedActivityChange)="onSelectedActivityChange()"
            (activityMouseEnter)="onActivityCardHover($event, true)"
            (activityMouseLeave)="onActivityCardHover($event, false)">
          </app-activity-results-listing>
        </mat-tab>
        <mat-tab #aviationEventsTab>
          <ng-template mat-tab-label>
            <div class="search-page__tab">
              <mat-icon class="search-page__tab-icon">event</mat-icon>
              <span class="search-page__tab-text">Events</span>
            </div>
          </ng-template>
          <app-event-results-listing
            #eventsResultsListing class="search-page__results" [query]="query"
            [state]="aviationEventsState" [aviationEvents]="pagedAviationEvents" [activeAviationEvent]="activeAviationEvent"
            [eventPageIndex]="eventPageIndex" [eventPageSize]="eventPageSize"
            [totalAviationEvents]="filteredAviationEvents.length"
            (filtersChanged)="onAviationEventsFiltersChanged()"
            (eventPageChanged)="onEventPageChanged($event)"
            (filtersDateChanged)="onAviationEventsFiltersDateChanged()"
            (eventMouseEnter)="onEventCardHover($event, true)"
            (eventMouseLeave)="onEventCardHover($event, false)"
            (showAirportsToggleChanged)="onShowAirportsToggleChanged()">
          </app-event-results-listing>
        </mat-tab>
      </mat-tab-group>
    </mat-sidenav>
    <mat-sidenav-content>
      <div class="search-page__sidebar-toggle" (click)="toggleSidebar()" [matTooltip]="toggleTooltip"
           matTooltipPosition="right">
        <mat-icon *ngIf="sidebarOpened" class="search-page__sidebar-toggle-icon">chevron_left</mat-icon>
        <mat-icon *ngIf="!sidebarOpened" class="search-page__sidebar-toggle-icon">chevron_right</mat-icon>
      </div>
      <app-results-map #map class="search-page__map"
                       [airports]="declutteredAirports" [activeAirport]="activeAirport" [selectedAirport]="selectedAirport"
                       [activities]="activities" [selectedActivity]="selectedActivity"
                       [aviationEvents]="filteredAviationEvents" [activeAviationEvent]="activeAviationEvent" [selectedAviationEvent]="selectedAviationEvent"
                       [initialBounds]="query.bounds" [message]="mapMessage"
                       [showAirports]="eventsResultsListing.showAirports || selectedTab !== aviationEventsTab"
                       [onEventsTab]="selectedTab === aviationEventsTab"
                       [aviationEventsFilter]="aviationEventFilter"
                       [initialLocation]="query.location"
                       (airportMouseEnter)="onAirportMarkerHover($event, true)"
                       (airportMouseLeave)="onAirportMarkerHover($event, false)"
                       (airportClick)="onAirportClick($event)"
                       (airportCardClose)="onCloseAirportCardWindow()"
                       (activityMouseEnter)="onActivityMarkerHover($event, true)"
                       (activityMouseLeave)="onActivityMarkerHover($event, false)"
                       (activityClick)="onActivityClick($event)"
                       (activityCardClose)="onCloseActivityWindow($event)"
                       (aviationEventMouseEnter)="onEventMarkerHover($event, true)"
                       (aviationEventMouseLeave)="onEventMarkerHover($event, false)">
      </app-results-map>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<div #backToSearchEl *ngIf="backToSearchVisible" class="search-page__back-to-search">
  <button type="button" (click)="backToSearch()" mat-fab class="search-page__back-to-search-btn" color="primary">
    <mat-icon>chevron_left</mat-icon>
  </button>
  <span (click)="backToSearch()" class="search-page__back-to-search-label">Back to Search</span>
</div>
